import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AiAssistantHistoryList from './aiAssistantHistoryList';
import AiAssistantHistoryTranscript from './aiAssistantHistoryTranscript';
import './aiAssistantHistoryPanel.scss';

export default function AiAssistantHistoryPanel({ labels, onStartNewChat }) {
  const [selectedSessionId, setSelectedSessionId] = useState(null);

  return (
    <div className="ais-history-panel">
      {selectedSessionId ? (
        <AiAssistantHistoryTranscript
          labels={labels}
          sessionId={selectedSessionId}
          onBack={() => setSelectedSessionId(null)}
        />
      ) : (
        <AiAssistantHistoryList
          labels={labels}
          onOpenConversation={setSelectedSessionId}
          onStartNewChat={onStartNewChat}
        />
      )}
    </div>
  );
}

AiAssistantHistoryPanel.propTypes = {
  labels: PropTypes.object.isRequired,
  onStartNewChat: PropTypes.func.isRequired,
};
